import { render, staticRenderFns } from "./section-tecno.vue?vue&type=template&id=ab0f5736&scoped=true"
import script from "./section-tecno.vue?vue&type=script&lang=js"
export * from "./section-tecno.vue?vue&type=script&lang=js"
import style0 from "./section-tecno.vue?vue&type=style&index=0&id=ab0f5736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0f5736",
  null
  
)

export default component.exports